import axios from 'axios';
import { API_URL } from '../config/apiConfig';


export const getClassLeaderboard = async (classId) => {
    try {
        const response = await axios.get(`${API_URL}/leaderboard`, {
            params: {
                classId
            },
            headers: {
                "Content-Type": "application/json"
            }
        });
        return Array.isArray(response.data) ? response.data : []; // ✅ Kui response pole massiiv, tagastame tühja massiivi
    } catch (error) {
        console.error("❌ Error fetching leaderboard:", error);
        return []; // ✅ Kui viga, tagastame tühja massiivi
    }
};

export const deleteLeaderboardScore = async (entryId) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.delete(`${API_URL}/leaderboard/${entryId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error) {
        console.error("❌ Error deleting leaderboard score:", error);
        throw error;
    }
};